<template>
    <div class="fw-lsdd">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <Cxdate @chaxun="chaxun"/>
        <div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div>
                    <div class="lsdd-item" v-for="item in list">
                        <span class="od-sp">{{item.memberName==null?'散客':item.memberName}}</span>
                        <span class="od-sp">{{item.createTime}}</span>
                        <span class="od-sp">消费金额：<span class="cstext">¥{{item.totalPrice}}</span></span>
                        <div style="display: flex;flex-direction: column" v-if="userType==2">
                            <div class="od-sp1" style="display: flex;flex-direction: row;align-items: center">结算方式：
                                <span v-if="item.payType==0">会员卡: ¥{{item.totalPrice}}</span>
                                <span v-if="item.payType==1">赠送金: ¥{{item.totalPrice}}</span>
                                <span v-if="item.payType==2">现金: ¥{{item.totalPrice}}</span>
                                <span v-if="item.payType==3">微信: ¥{{item.totalPrice}}</span>
                                <span v-if="item.payType==4">支付宝: ¥{{item.totalPrice}}</span>
                                <span v-if="item.payType==5">美团: ¥{{item.totalPrice}}</span>
                                <span v-if="item.payType==6">抖音: ¥{{item.totalPrice}}</span>
                                <el-popover placement="right" width="120" trigger="click" v-if="item.payType==7"
                                            style="margin-top: 1px" @show="toOrderBlend(item.id)">
                                    <div style="display:flex;flex-direction: column">
                                        <span class="ob-sp" v-if="orderBlend.card&&orderBlend.card>0">会员卡: {{orderBlend.card}}</span>
                                        <span class="ob-sp" v-if="orderBlend.give&&orderBlend.give>0">赠送金: {{orderBlend.give}}</span>
                                        <span class="ob-sp" v-if="orderBlend.cash&&orderBlend.cash>0">现  金: {{orderBlend.cash}}</span>
                                        <span class="ob-sp"
                                              v-if="orderBlend.wx&&orderBlend.wx>0">微  信: {{orderBlend.wx}}</span>
                                        <span class="ob-sp"
                                              v-if="orderBlend.ali&&orderBlend.ali>0">支付宝: {{orderBlend.ali}}</span>
                                        <span class="ob-sp"
                                              v-if="orderBlend.mt&&orderBlend.mt>0">美  团: {{orderBlend.mt}}</span>
                                        <span class="ob-sp"
                                              v-if="orderBlend.dy&&orderBlend.dy>0">抖  音: {{orderBlend.dy}}</span>
                                        <span class="ob-sp" v-if="orderBlend.arrears&&orderBlend.arrears>0">欠  款:{{orderBlend.arrears}}</span>
                                        <span class="ob-sp"
                                              v-if="orderBlend.sj&&orderBlend.sj>0">商  家: {{orderBlend.sj}}</span>
                                    </div>
                                    <el-button type="text" slot="reference" style="font-size: 11px">混合支付</el-button>
                                </el-popover>
                            </div>
                            <span class="od-sp1">营业额：¥{{item.turnover}} </span>
                            <span class="od-sp1">门店入账：¥{{item.actual}}</span>
                        </div>
                        <div>
                            <span class="nr-bt">内容详情</span>
                            <div class="od-info" v-for="it in item.orderInfoList">
                                <div class="itemname">
                                    <span class="cstext" v-if="it.commodityType==0">
                                    <span v-if="it.commoditySign==0">(项目)</span>
                                    <span v-if="it.commoditySign==1||it.commoditySign==4">(套餐消耗)</span>
                                    <span v-if="it.commoditySign==2">(会员卡消耗)</span>
                                    <span v-if="it.commoditySign==3">(年卡消耗)</span>
                                    <span v-if="it.commoditySign==5||it.commoditySign==10">(商城消耗)</span>
                                    </span>
                                    <span class="cstext" v-if="it.commodityType==1">(卖品)</span>
                                    <span class="cstext" v-if="it.commodityType==2">(套餐)</span>
                                    <span class="cstext" v-if="it.commodityType==3">(开卡)</span>
                                    <span class="cstext" v-if="it.commodityType==4">(充值)</span>
                                    <span class="cstext" v-if="it.commodityType==5">(品项)</span>
                                    <span class="cstext" v-if="it.commodityType==10">(成品)</span>
                                    <span>{{it.commodityName}}</span>
                                </div>
                                <span class="itemnum">x 1</span>
                                <span class="itemjg">¥ {{it.price}}</span>
                            </div>
                        </div>
                        <div class="od-btn">
                            <span @click="toInfo(item)">订单详情</span>
                            <span @click="toChedan(item)" v-if="chexiao">撤销</span>
                            <span @click="toDelOrder(item)" v-if="shanchu">删除</span>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <div style="padding: 15px;">
                <div class="lsdd-item">
                    <span class="od-sp">{{order.memberName==null?'散客':order.memberName}}</span>
                    <span class="od-sp">{{order.createTime}}</span>
                    <span class="od-sp">消费金额：<span class="cstext">¥{{order.totalPrice}}</span></span>
                    <div>
                        <span class="nr-bt">内容详情</span>
                        <div class="od-mx" v-for="it in orderInfos">
                            <div class="od-info">
                                <div class="itemname">
                                    <span class="cstext" v-if="it.commodityType==0">
                                    <span v-if="it.commoditySign==0">(项目)</span>
                                    <span v-if="it.commoditySign==1||it.commoditySign==4">(套餐消耗)</span>
                                    <span v-if="it.commoditySign==2">(会员卡消耗)</span>
                                    <span v-if="it.commoditySign==3">(年卡消耗)</span>
                                    <span v-if="it.commoditySign==5||it.commoditySign==10">(商城消耗)</span>
                                    </span>
                                    <span class="cstext" v-if="it.commodityType==1">(卖品)</span>
                                    <span class="cstext" v-if="it.commodityType==2">(套餐)</span>
                                    <span class="cstext" v-if="it.commodityType==3">(开卡)</span>
                                    <span class="cstext" v-if="it.commodityType==4">(充值)</span>
                                    <span class="cstext" v-if="it.commodityType==5">(品项)</span>
                                    <span class="cstext" v-if="it.commodityType==10">(成品)</span>
                                    <span>{{it.commodityName}}</span>
                                </div>
                                <span class="itemnum">x 1</span>
                                <span class="itemjg">¥ {{it.price}}</span>
                                <span class="itememp" @click="toEmps(it)" v-if="addEmp">更改员工</span>
                            </div>
                            <div style="margin-top: 1px">
                                <div class="od-emps" v-for="item in it.empAcs">
                                    <div class="empnaa">
                                        <span class="empname">{{item.sxName}}: {{item.empName}}</span>
                                        <span class="empdel" @click="toDelEmp(item)" v-if="delEmp">删除</span>
                                    </div>
                                    <div class="empnbb">
                                        <span class="empcmn">业绩: {{item.ach}}</span>
                                        <span class="empcmn">提成: {{item.cmn}}</span>
                                        <span class="empcmn">分段: {{item.fdCmn}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="empShow" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{item.commodityName}}</span>
                    <span class="jg">¥{{item.price}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">业绩</span>
                        <el-input v-model="emp.ach" size="mini" placeholder="请输入业绩" class="ki"></el-input>
                    </div>
                    <div class="tiaozheng" style="margin-top: 10px">
                        <span class="xiadanjiage">提成</span>
                        <el-input v-model="emp.cmnVal" size="mini" placeholder="请输入提成" class="ki" style="width: 40%"></el-input>
                        <el-radio-group v-model="emp.cmnType" style="margin-left: 3px">
                            <el-radio :label="1">比例</el-radio>
                            <el-radio :label="2">固定</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                                    <span class="empname1" @click="setLEmp(emp,1)"
                                          @dblclick="setDEmp(emp,1)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(1)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(1)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                                    <span class="empname1" @click="setLEmp(emp,2)"
                                          @dblclick="setDEmp(emp,2)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(2)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(2)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                                    <span class="empname1" @click="setLEmp(emp,3)"
                                          @dblclick="setDEmp(emp,3)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(3)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(3)">点</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addData"> 确定</div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import Cxdate from "./../common/cxdate.vue";
    import {debounce} from 'throttle-debounce';

    export default {
        components: {Cxdate},
        data() {
            return {
                title: '流水对单',
                fwUser: {},
                deptId: '',
                token: '',
                userType: '',
                dateType: 0,
                staDate: '',
                endDate: '',

                list: [],
                loading: false,
                finished: false,
                page: 1,
                orderBlend: {},

                mxShow: false,
                order: {},
                orderInfos: [],

                empShow: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',
                emp: {},

                qxs: ['syCto', 'syDelOrder', 'lsAddEmp', 'lsDelEmp'],
                permissionList: [],
                chexiao: false,
                shanchu: false,
                addEmp: false,
                delEmp: false,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.getFwEmps()
            this.getPermissionList()
            this.onLoad = debounce(300, this.onLoad);
        },
        methods: {

            async getPermissionList() {
                let data = {
                    token: this.token,
                    qxs: JSON.stringify(this.qxs)
                }
                let res = await this.$post("/fw/getPermissionList", data)
                if (res.permissionList.length > 0) {
                    this.permissionList = res.permissionList
                    if (this.permissionList.indexOf('syCto') > -1) {
                        this.chexiao = true
                    }
                    if (this.permissionList.indexOf('syDelOrder') > -1) {
                        this.shanchu = true
                    }
                    if (this.permissionList.indexOf('lsAddEmp') > -1) {
                        this.addEmp = true
                    }
                    if (this.permissionList.indexOf('lsDelEmp') > -1) {
                        this.delEmp = true
                    }
                }
            },
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    dateType: this.dateType,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    orderStatus: 1,
                    ht: 5,
                    currentPage
                }
                let res = await this.$get("/fw/getFwOrderList", data)
                if (res.code == 200) {
                    const count = res.dataSet.list.length
                    const newList = res.dataSet.list
                    const list = this.list.concat(newList)
                    if (list.length < 30) {
                        this.list = this.quchong(list, "id")
                    } else {
                        this.list = list
                    }
                    this.page = this.page + 1
                    this.loading = false
                    if (count < 10 && count == 0) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            },
            //获取混合支付的详细明细
            async toOrderBlend(orderId) {
                let res = await this.$get("/sw/getOrderBlend", {orderId: orderId})
                if (res.orderBlend) {
                    this.orderBlend = res.orderBlend
                }
            },
            toInfo(item) {
                if (!item.id) {
                    return;
                }
                this.mxShow = true
                this.getOrderInfo(item)
            },
            async getOrderInfo(item) {
                let res = await this.$get("/sw/getSwOrderDetails", {orderId: item.id});
                this.order = item
                this.orderInfos = res.syOrderInfos
            },
            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },


            //撤单弹框
            toChedan(item) {
                this.$dialog.confirm({
                    title: '提示',
                    message: '是否撤单?'
                }).then(() => {
                    this.chedan(item)
                }).catch(() => {
                    // on cancel
                });
            },
            //撤销订单
            async chedan(item) {
                let url = '/fw/fwRevokeOrder';
                if (item.payType == 3 || item.payType == 4) {
                    url = '/fw/fwRefundSqb'
                }
                let res = await this.$post(url, {id: item.id, token: this.token});
                if (res.code == 200) {
                    this.caozuo()
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            setLEmp(item) {
                this.setUnchecked();
                item.status = 1
            },
            setDEmp(item) {
                this.setUnchecked();
                item.status = 2
            },
            // 将选中的人状态更改为没选中
            setUnchecked() {
                this.changeEmpFalse(this.fEmps);
                this.changeEmpFalse(this.sEmps);
                this.changeEmpFalse(this.tEmps)
            },
            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    if (item.status != 0) {
                        item.status = 0
                    }
                })
            },

            toEmps(item) {
                this.item = item
                this.emp = {
                    orderInfoId: item.id,
                    employeeId: '',
                    appoint: '',
                    station: '',
                    gradeId: '',
                    ach: 0,
                    cmnType:1,
                    cmnVal:'',
                }
                this.empShow = true
                this.setUnchecked()
            },

            //删除员工
            toDelEmp(item) {
                this.$dialog.confirm({
                    title: '提示',
                    message: '是否删除?'
                }).then(() => {
                    this.delAc(item)
                }).catch(() => {
                    // on cancel
                });
            },

            async delAc(item) {
                let res = await this.$post("/sw/delSwEmpAc", {id: item.id});
                if (res.code == 200) {
                    this.getOrderInfo(this.order)
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async addData() {
                let emp = {}
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.status != 0) {
                            emp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.status != 0) {
                            emp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.status != 0) {
                            emp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (!emp.empId){
                    this.$notify({type: 'danger', message: "请选择员工"});
                    return;
                }

                this.emp.employeeId = emp.empId
                this.emp.appoint = emp.status
                this.emp.station = emp.station
                this.emp.gradeId = emp.gradeId
                let res = await this.$post("/sw/saveSwEmpAc", this.emp)
                if (res.code == 200) {
                    this.empShow = false
                    this.getOrderInfo(this.order)
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            //删除弹框
            toDelOrder(item) {
                this.$dialog.confirm({
                    title: '提示',
                    message: '是否删除?'
                }).then(() => {
                    this.delOrder(item)
                }).catch(() => {
                    // on cancel
                });
            },
            //删除订单
            async delOrder(item) {
                let res = await this.$post("/fw/fwDelOrder", {id: item.id});
                if (res.code == 200) {
                    this.caozuo()
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            //去重
            quchong(arr, property) {
                const seen = new Set();
                return arr.filter(item => {
                    const key = item[property];
                    return !seen.has(key) && seen.add(key);
                });
            },
            caozuo() {
                this.dateType = 0
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-lsdd {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #F3F2F7;
    }

    .lsdd-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 11px;
        margin: 5px;
        background-color: #FFFFFF;
        padding: 12px 8px;
    }

    .od-sp {
        height: 23px;
        line-height: 23px;
    }

    .od-sp1 {
        height: 23px;
        line-height: 23px;
        color: #ACACAC;
    }

    .ob-sp {
        font-size: 11px;
    }

    .cstext {
        color: #F79906;
        font-size: 11px
    }

    .nr-bt {
        font-size: 13px;
        height: 32px;
        line-height: 35px;
        display: block;
        border-bottom: #EEEEEE solid 1px;
        margin-bottom: 8px;
    }

    .od-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .itemname {
        width: 50%;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 30px;
        line-height: 30px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .itemnum {
        width: 30px;
        height: 30px;
        line-height: 30px;
    }

    .itemjg {
        width: 15%;
        height: 30px;
        line-height: 30px;
    }

    .itememp {
        height: 30px;
        line-height: 30px;
        color: #2b94ff;
    }

    .od-btn {
        margin: 35px 40px 0px 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
    }

    .od-btn span {
        padding: 3px;
        cursor: pointer;
        font-weight: bold;
    }

    .od-mx {
        display: flex;
        flex-direction: column;
        margin-top: 12px;
    }

    .od-emps {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5px 0;
    }

    .empnaa {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .empnbb {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .od-emps .empname {
        width: 40%;
        height: 20px;
        line-height: 20px;
        font-size: 10px;
    }

    .od-emps .empcmn {
        width: 30%;
        height: 20px;
        line-height: 20px;
        font-size: 10px;
    }

    .od-emps .empdel {
        width: 35px;
        color: red;
    }

    .fw-gw-emps {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        height: 268px;
        border-bottom: #eeeeee solid 1px;
    }

    .emp-gw {
        width: 100%;
        text-align: center;
        border-right: #eeeeee solid 1px;
    }

    .gw {
        display: block;
        height: 30px;
        line-height: 30px;
        border-bottom: #eeeeee solid 1px;
    }

    .fw-gw-emp {
        height: 230px;
        display: flex;
        flex-direction: column;
        padding: 0px 5px;
        overflow: auto;
    }

    .emp {
        height: 20px;
        line-height: 20px;
        text-align: left;
        margin: 5px 0px 0px 5px;
        display: flex;
        flex-direction: row;
    }

    .empname1 {
        width: 90%;
    }

    .empgl {
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        margin: 0 3px;
        border-radius: 25px;
        color: #ffffff;
        position: relative;
        background-color: #616EB0;
        right: 0px;
    }

    .adddatabtn {
        width: 100%;
        height: 32px;
        font-size: 18px;
        background-color: #2b94ff;
        text-align: center;
        color: #ffffff;
        line-height: 32px;
    }

    .fwgr-item-info {
        display: flex;
        flex-direction: column;
        padding-left: 5px;
    }

    .fwgr-item-info .mc {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
    }

    .fwgr-item-info .nr {
        font-size: 11px;
        height: 20px;
        line-height: 20px;
        color: #A8A6A6;
    }

    .fwgr-item-info .jg {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
        color: red;
    }

    .tiaozheng {
        margin-top: 5px;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .xiadanjiage {
        width: 35px;
        font-size: 11px;
        margin-right: 8px;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff;
        border-radius: 0px;
        border-bottom-color: #EEEEEE;
    }

    .ki {
        width: 60%;
    }

</style>